import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowUpOutlinedIcon } from '@getgo/chameleon-icons/react';
import { Button } from '@getgo/chameleon-material-ui';
import { Skeleton } from '@material-ui/lab';
import classNames from 'classnames';
import NoResults from "../NoResults";
import TextTruncate from "../TextTruncate";
import React, { useState } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import classes from './index.module.scss';
const INITIAL_ITEM_COUNT = 25;
const TABLE_ROW_HEIGHT = 56;
const TABLE_ROW_COLLAPSED_HEIGHT = 36;
function getCount(data) {
    var _a;
    return (_a = data === null || data === void 0 ? void 0 : data.length) !== null && _a !== void 0 ? _a : 0;
}
const InfiniteList = ({ loading, columns, compact, more, sorting, data, className, rowClassName, initialSize = INITIAL_ITEM_COUNT, selectedRows, onClick, onLoad, onSort, }) => {
    var _a, _b;
    const [itemCount, setItemCount] = useState(initialSize);
    const isItemLoaded = index => (more ? index < getCount(data) : true);
    const itemHeight = compact ? TABLE_ROW_COLLAPSED_HEIGHT : TABLE_ROW_HEIGHT;
    const [tableBody, setTableBody] = useState(null);
    // generate fake rows for skeleton
    const skeleton = {};
    if (loading && (data === null || data === void 0 ? void 0 : data.length) === 0) {
        if ((data === null || data === void 0 ? void 0 : data.length) === 0) {
            data = [...new Array(initialSize)].map((_, index) => ({ id: index.toString() }));
            for (let index = 0; index < initialSize; index++) {
                skeleton[index] = {};
                columns.forEach(column => {
                    skeleton[index][column.accessor] = Math.floor(Math.random() * 30 + 50);
                });
            }
        }
        else {
            for (let index = 0; index < data.length; index++) {
                skeleton[index] = {};
                columns.forEach(column => {
                    skeleton[index][column.accessor] = Math.floor(Math.random() * 30 + 50);
                });
            }
        }
    }
    const handleLoadMoreItems = () => {
        if (more) {
            onLoad();
        }
        return null;
    };
    const ItemRenderer = ({ index, style }) => {
        const selected = data && data[index] && (selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.find(row => row === data[index].id));
        const currentRowData = data && data[index];
        return (_jsx("div", Object.assign({ className: classNames(classes.row, selected && classes.selected, onClick && classes.clickable, rowClassName), style: style, onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(currentRowData, !!selected) }, { children: columns.map(column => (_jsx("div", Object.assign({ className: classNames(classes.cell, !currentRowData && classes.empty, column.cellClassName) }, { children: loading ? (_jsx(Skeleton, { className: classes.skeleton, width: skeleton[index] ? `${skeleton[index][column.accessor]}%` : '50%', variant: "rect" }, void 0)) : (currentRowData &&
                    column.Cell({
                        value: currentRowData[column.accessor],
                        row: {
                            original: currentRowData,
                        },
                    })) }), column.accessor))) }), index));
    };
    React.useEffect(() => {
        const userCount = getCount(data);
        setItemCount(more ? userCount + 1 : data ? Math.max(userCount, 1) : 0);
    }, [data, more]);
    const hasScroll = ((_a = tableBody === null || tableBody === void 0 ? void 0 : tableBody._outerRef) === null || _a === void 0 ? void 0 : _a.scrollHeight) > ((_b = tableBody === null || tableBody === void 0 ? void 0 : tableBody._outerRef) === null || _b === void 0 ? void 0 : _b.clientHeight);
    return (_jsxs("div", Object.assign({ className: classNames(classes.content, className) }, { children: [_jsx("header", Object.assign({ className: classNames(classes.header, hasScroll && classes.scroll) }, { children: columns.map(column => (_jsx("div", Object.assign({ className: classNames(classes.cell, column.cellClassName), onClick: () => onSort === null || onSort === void 0 ? void 0 : onSort({
                        id: column.accessor,
                        descending: sorting.id === column.accessor ? !sorting.descending : false,
                    }) }, { children: !sorting || column.disableSortBy ? (_jsx(TextTruncate, Object.assign({ className: classes.text }, { children: typeof column.Header === 'string' ? column.Header : column.Header() }), void 0)) : (_jsx(Button, Object.assign({ className: classNames(classes.sorting, sorting.descending && classes.descending), size: "small", endIcon: sorting.id === column.accessor && _jsx(ArrowUpOutlinedIcon, {}, void 0) }, { children: typeof column.Header === 'string' ? column.Header : column.Header() }), void 0)) }), column.accessor))) }), void 0), _jsx(AutoSizer, { children: ({ height, width }) => (_jsx(InfiniteLoader, Object.assign({ isItemLoaded: isItemLoaded, loadMoreItems: handleLoadMoreItems, itemCount: itemCount }, { children: ({ onItemsRendered, ref }) => (_jsx(FixedSizeList, Object.assign({ className: classes.body, ref: list => {
                            ref(list);
                            setTableBody(list);
                        }, onItemsRendered: onItemsRendered, itemCount: itemCount, itemSize: itemHeight, height: height, width: width }, { children: ItemRenderer }), void 0)) }), void 0)) }, void 0), !loading && (data === null || data === void 0 ? void 0 : data.length) === 0 && _jsx(NoResults, {}, void 0)] }), void 0));
};
export default InfiniteList;
//# sourceMappingURL=index.js.map